import React from "react";
import PropTypes from "prop-types";

import Nav from "../NewMessage/Nav";

const FormTemplate = ({
  messageType,
  name,
  message,
  onChangeType,
  onChangeName,
  onChangeMessage
}) => (
  <div>
    <Nav
      hideInactive={true}
      messageType={messageType}
      onToggleMessageType={onChangeType}
    />

    <div className="mb-15">
      <label htmlFor="messaging-temp-name">Name *</label>
      <input id="messaging-temp-name" className="form-control" value={name} onChange={onChangeName} />
    </div>

    <div className="mb-15">
      <label htmlFor="messaging-temp-message">Message *</label>
      <textarea
        id="messaging-temp-message"
        className="form-control"
        value={message}
        onChange={onChangeMessage}
      />
    </div>
  </div>
);

FormTemplate.propTypes = {
  messageType: PropTypes.string,
  name: PropTypes.string,
  message: PropTypes.string,
  onChangeType: PropTypes.func,
  onChangeName: PropTypes.func,
  onChangeMessage: PropTypes.func
};

export default FormTemplate;
